import { IContractChargeDatesRepository } from 'modules/customer/domain/repositories';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';

export default class VectisContractChargeDatesRepository
  implements IContractChargeDatesRepository
{
  constructor(private httpProvider: IHTTPProvider) {}

  public update: IContractChargeDatesRepository['update'] = async ({
    contractId,
    date,
  }) => {
    return this.httpProvider.post(
      `contratos/${contractId}/alterarDataCobranca`,
      {
        novaDataCobranca: date,
      },
    );
  };
}
